import React from "react";
import Detail from "./Detail";
import Default from "./Default";
import Chat from "./Chat";
import Account from "./Account";
import renderPropsComposer from "utils/renderPropsComposer";

export default function index(props: any) {
  return renderPropsComposer(
    {
      matcher: ({ type }: any) => type === "detail",
      render: () => {
        return <Detail {...props} />;
      },
    },
    {
      matcher: ({ type }: any) => type === "chat",
      render: () => {
        return <Chat {...props} />;
      },
    },
    {
      matcher: ({ type }: any) => type === "account",
      render: () => {
        return <Account {...props} />;
      },
    },
    {
      matcher: "default",
      render: () => {
        return <Default {...props} />;
      },
    }
  )(props);
}
